import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API_BASE = `${BACKEND_URL}/api`;

const client = axios.create({
    baseURL: API_BASE,
    timeout: 25000,
    headers: { "Content-Type": "application/json" },
});

function unwrapError(err) {
    const detail = err?.response?.data?.detail;
    const status = err?.response?.status;
    const message = typeof detail === "string" ? detail : (detail?.[0]?.msg || err.message);
    const wrapped = new Error(message || "Something went wrong.");
    wrapped.status = status;
    wrapped.original = err;
    return wrapped;
}

export const api = {
    async reviewPreference(token, choice=null, google_confirmation=false) {
        const config={headers:{'X-Review-Token':token}};
        try { return (await (choice ? client.post('/reviews',{choice,google_confirmation},config) : client.get('/reviews',config))).data; }
        catch(e) { throw unwrapError(e); }
    },
    async cancellationPolicy() {
        try { return (await client.get('/booking/cancellation-policy')).data; } catch(e) { throw unwrapError(e); }
    },
    async manageBooking(token, action='', payload=null) {
        const config={headers:{'X-Booking-Management-Token':token},timeout:120000};
        try { return (await (payload ? client.post(`/booking/manage${action}`,payload,config) : client.get(`/booking/manage${action}`,config))).data; }
        catch(e) { throw unwrapError(e); }
    },
    async cartQuote(items) {
        try { return (await client.post("/booking/cart/quote", {items})).data; } catch (e) { throw unwrapError(e); }
    },
    async cartAvailability(items, start_date, end_date) {
        try { return (await client.post("/booking/cart/availability", {items, start_date, end_date})).data; } catch (e) { throw unwrapError(e); }
    },
    async cartCheckout(payload, key) {
        try { return (await client.post("/booking/cart/checkout", payload, {headers: {"X-Booking-Key": key}, timeout:60000})).data; } catch (e) { throw unwrapError(e); }
    },
    async cartComplete(key) {
        try { return (await client.post("/booking/cart/complete", {}, {headers: {"X-Booking-Key": key}, timeout:60000})).data; } catch (e) { throw unwrapError(e); }
    },
    async cartSession(key) {
        try { return (await client.get("/booking/cart/session", {headers: {"X-Booking-Key": key}})).data; } catch (e) { throw unwrapError(e); }
    },
    async catalogue() {
        try { return (await client.get("/booking/catalogue")).data; } catch (e) { throw unwrapError(e); }
    },
    async health() {
        try { return (await client.get("/booking/health")).data; }
        catch (e) { throw unwrapError(e); }
    },
    async listCategories() {
        try { return (await client.get("/booking/categories")).data; }
        catch (e) { throw unwrapError(e); }
    },
    async listServices(categoryId) {
        try { return (await client.get("/booking/services", { params: { category_id: categoryId } })).data; }
        catch (e) { throw unwrapError(e); }
    },
    async availableDates({ serviceId, startDate, endDate }) {
        try {
            return (await client.get("/booking/available-dates", {
                params: { service_id: serviceId, start_date: startDate, end_date: endDate },
            })).data;
        } catch (e) { throw unwrapError(e); }
    },
    async listSlots({ serviceId, date, mode }) {
        try {
            return (await client.get("/booking/slots", { params: { service_id: serviceId, date, ...(mode ? { mode } : {}) } })).data;
        } catch (e) { throw unwrapError(e); }
    },
    async createAppointment(payload) {
        try {
            return (await client.post("/booking/appointments", payload)).data;
        } catch (e) { throw unwrapError(e); }
    },
    async getAppointmentStatus(id) {
        try {
            return (await client.get(`/booking/appointments/${id}/status`)).data;
        } catch (e) { throw unwrapError(e); }
    },
    async getPublicPayment(id, token) {
        try {
            return (await client.get(`/booking/appointments/${id}/payment/public`, { params: { token } })).data;
        } catch (e) { throw unwrapError(e); }
    },
    async regenerateBookingPayment(id, token) {
        try {
            return (await client.post(`/booking/appointments/${id}/payment/regenerate`, null, { params: { token } })).data;
        } catch (e) { throw unwrapError(e); }
    },
    async cancelBooking(id, token) {
        try {
            return (await client.post(`/booking/appointments/${id}/cancel`, null, { params: { token } })).data;
        } catch (e) { throw unwrapError(e); }
    },
    async postPublicMarketingOptIn(payload) {
        // Fire-and-forget; never blocks a booking. Server enforces opt-out overrides.
        try { return (await client.post("/public/comms/opt-in", payload)).data; }
        catch (e) { throw unwrapError(e); }
    },
};
